import React, {useCallback, useRef, useState} from 'react';
import Alerter from '../React/Components/Common/Alerter';
import {
    needsReplaceCartConfirmation,
    REPLACE_CART_ACCEPT,
    REPLACE_CART_CANCEL,
    REPLACE_CART_TEXT,
    REPLACE_CART_TITLE,
} from './cartConfirmations';

export function useReplaceCartConfirmation() {
    const [open, setOpen] = useState(false);
    const resolverRef = useRef(null);

    const request = useCallback((snapshot) => {
        if (!needsReplaceCartConfirmation(snapshot)) {
            return Promise.resolve({confirmed: true, cleanCart: false});
        }
        if (resolverRef.current) {
            return Promise.resolve({confirmed: false, cleanCart: false});
        }
        return new Promise((resolve) => {
            resolverRef.current = resolve;
            setOpen(true);
        });
    }, []);

    const handleAccept = useCallback(() => {
        setOpen(false);
        resolverRef.current?.({confirmed: true, cleanCart: true});
        resolverRef.current = null;
    }, []);

    const handleCancel = useCallback(() => {
        setOpen(false);
        resolverRef.current?.({confirmed: false, cleanCart: false});
        resolverRef.current = null;
    }, []);

    const element = open ? (
        <Alerter
            cancelText={REPLACE_CART_CANCEL}
            acceptText={REPLACE_CART_ACCEPT}
            onAccept={handleAccept}
            onCancel={handleCancel}
        >
            <h3 className="mb-5">
                <strong>{REPLACE_CART_TITLE}</strong>
            </h3>
            <div className="mb-5">{REPLACE_CART_TEXT}</div>
        </Alerter>
    ) : null;

    return [element, request];
}
